
















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class AgreementDialog extends Vue {
  @Prop({ default: false })
  visible!: boolean;

  // 点击「我已阅读并同意」：先通知父页面已同意（勾选外层复选框），再关闭
  onAgree() {
    this.$emit('agree');
    this.$emit('close');
  }
}
